import round from 'lodash/round'

export default class EarningsCallsPreviewSummary {
  static getEpsEstimateMarketData({ reported, estimate }) {
    const data = {
      label: 'EPS 市場預期',
      value: '-',
      valueSuffix: '',
      classname: '',
    }

    const isIncalculable = typeof reported !== 'number' || typeof estimate !== 'number'
    if (isIncalculable) {
      return data
    }

    const isAllPositiveNumbers = reported >= 0 && estimate >= 0
    if (isAllPositiveNumbers) {
      if (reported > estimate) {
        data.label = 'EPS 比市場預期高'
        data.value = `+${round(((reported - estimate) / estimate) * 100, 2)}`
        data.valueSuffix = '%'
        data.classname = 'is-red'
      }
      if (reported < estimate) {
        data.label = 'EPS 比市場預期低'
        data.value = `-${round(((estimate - reported) / estimate) * 100, 2)}`
        data.valueSuffix = '%'
        data.classname = 'is-green'
      }
      if (reported === estimate) {
        data.label = 'EPS 等於市場預期'
        data.value = '符合預期'
      }
    } else { // eslint-disable-next-line no-lonely-if
      if (reported > estimate) {
        data.label = 'EPS 比市場預期高'
        data.value = '高於預期'
        data.classname = 'is-red'
      }
      if (reported < estimate) {
        data.label = 'EPS 比市場預期低'
        data.value = '低於預期'
        data.classname = 'is-green'
      }
      if (reported === estimate) {
        data.label = 'EPS 等於市場預期'
        data.value = '符合預期'
      }
    }

    return data
  }

  static getEpsYoYData({ reported, reportedLastYear }) {
    const data = {
      label: 'EPS 年成長',
      value: '-',
      valueSuffix: '',
      classname: '',
    }

    const isIncalculable = typeof reported !== 'number' && typeof reportedLastYear !== 'number'
    if (isIncalculable) {
      return data
    }

    if (reported > 0) {
      if (reportedLastYear > 0) {
        if (reported > reportedLastYear) {
          data.value = `+${round(((reported - reportedLastYear) / reportedLastYear) * 100, 2)}`
          data.valueSuffix = '%'
          data.classname = 'is-red'
        }
        if (reported === reportedLastYear) {
          data.value = '0'
          data.valueSuffix = '%'
        }
        if (reported < reportedLastYear) {
          data.value = `-${round(((reportedLastYear - reported) / reportedLastYear) * 100, 2)}`
          data.valueSuffix = '%'
          data.classname = 'is-green'
        }
      }
      if (reportedLastYear === 0) {
        data.value = '無法計算'
      }
      if (reportedLastYear < 0) {
        data.value = '轉虧為盈'
        data.classname = 'is-red'
      }
    }

    if (reported === 0) {
      if (reportedLastYear > 0) {
        data.value = '-100'
        data.valueSuffix = '%'
        data.classname = 'is-green'
      }
      if (reportedLastYear === 0) {
        data.value = '無法計算'
      }
      if (reportedLastYear < 0) {
        data.value = '無法計算'
      }
    }

    if (reported < 0) {
      if (reportedLastYear > 0) {
        data.value = '轉盈為虧'
        data.classname = 'is-green'
      }
      if (reportedLastYear === 0) {
        data.value = '無法計算'
      }
      if (reportedLastYear < 0) {
        if (reported > reportedLastYear) {
          data.value = '虧損縮小'
        }
        if (reported === reportedLastYear) {
          data.value = '無法計算'
        }
        if (reported < reportedLastYear) {
          data.value = '虧損擴大'
        }
      }
    }

    return data
  }
}
